"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Forms/StatusView/SentFormView.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _moment = require('moment'); var _moment2 = _interopRequireDefault(_moment);





var _forms = require('shared/services/forms');
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _ui = require('web/services/ui');
var _noticeBar = require('web/services/context/noticeBar');
var _store = require('web/store');
var _FilledPage = require('web/components/Forms/FilledPage'); var _FilledPage2 = _interopRequireDefault(_FilledPage);
var _FormStatusChip = require('web/components/Forms/FormStatusChip'); var _FormStatusChip2 = _interopRequireDefault(_FormStatusChip);
var _openFormChat = require('web/components/Forms/openFormChat');





/* What a field shows: staff values, the family's answers, the signature
 * and the date filled in at signing. */
const valueFor = (form) => (field) => {
  const signed = _forms.isSetTime.call(void 0, form.SubmittedAt) ? _moment2.default.call(void 0, form.SubmittedAt).format(_forms.FORM_DATE_FORMAT) : ''
  if (field.filler === 'auto') return signed
  if (field.type === 'signature') return form.SignerName ? `${form.SignerName}  ${signed}` : ''
  const value = field.filler === 'staff' ? _optionalChain([form, 'access', _ => _.StaffValues, 'optionalAccess', _2 => _2[field.id]]) || '' : _optionalChain([form, 'access', _3 => _3.Answers, 'optionalAccess', _4 => _4.values, 'optionalAccess', _5 => _5[field.id]]) || ''
  return field.type === 'date' ? _forms.formDate.call(void 0, value) : value
}

const RowsList = ({ form }) => {
  const tables = form.Form.fields.filter(field => field.type === 'rows' && field.rows)
  const rows = _optionalChain([form, 'access', _6 => _6.Answers, 'optionalAccess', _7 => _7.rows]) || []
  if (!tables.length) return _react2.default.createElement('p', { className: "forms-muted", __self: this, __source: {fileName: _jsxFileName, lineNumber: 34}}, "This form has no rows."    )
  return (
    _react2.default.createElement(_react2.default.Fragment, null
      ,  tables.map(table => {
        const mine = rows.filter(row => row.field === table.id)
        // A row's initials and result show once each, from the row.
        const columns = table.rows.columns.filter(_forms.isRowValueColumn)
        const hasResult = table.rows.columns.some(column => column.type === 'result')
        const byDay = table.rows.mode === 'day'
        return (
          _react2.default.createElement('section', { key: table.id, className: "forms-status--rows", __self: this, __source: {fileName: _jsxFileName, lineNumber: 44}}
            , _react2.default.createElement('h3', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 45}}, table.rows.item || table.label || 'Rows')
            ,  mine.length === 0
              ? _react2.default.createElement('p', { className: "forms-muted", __self: this, __source: {fileName: _jsxFileName, lineNumber: 47}}, "No rows yet."  )
              : (
                _react2.default.createElement('div', { className: "forms-table-wrap", __self: this, __source: {fileName: _jsxFileName, lineNumber: 49}}
                  , _react2.default.createElement('table', { className: "forms-table", __self: this, __source: {fileName: _jsxFileName, lineNumber: 50}}
                    , _react2.default.createElement('thead', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 51}}
                      , _react2.default.createElement('tr', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 52}}
                        ,  byDay && _react2.default.createElement('th', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 53}}, "Day") 
                        ,  columns.map(column => _react2.default.createElement('th', { key: column.id, __self: this, __source: {fileName: _jsxFileName, lineNumber: 54}}, column.label)) 
                        , _react2.default.createElement('th', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 55}}, "Initials")
                        ,  hasResult && _react2.default.createElement('th', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 56}}, "Result") 
                        , _react2.default.createElement('th', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 57}}, "Added")
                      )
                    )
                    , _react2.default.createElement('tbody', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 60}}
                      ,  mine.map(row => (
                        _react2.default.createElement('tr', { key: row.id, __self: this, __source: {fileName: _jsxFileName, lineNumber: 62}}
                          ,  byDay && _react2.default.createElement('td', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 63}}, row.day) 
                          ,  columns.map(column => _react2.default.createElement('td', { key: column.id, __self: this, __source: {fileName: _jsxFileName, lineNumber: 64}}, _optionalChain([row, 'access', _8 => _8.values, 'optionalAccess', _9 => _9[column.id]]) || '')) 
                          , _react2.default.createElement('td', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 65}}, row.initials)
                          ,  hasResult && _react2.default.createElement('td', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 66}}, row.result ? _forms.ROW_RESULT_LABELS[row.result] : '') 
                          , _react2.default.createElement('td', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 67}}, _moment2.default.call(void 0, row.added).format('MMM D, LT'))
                        )
                      ))
                    )
                  )
                )
                )
          )
        )
      })
    )
  )
}

/* The read-only status view behind a staff form link (screen 19): the pages
 * with every value drawn on them, the log's rows, and the status, kept
 * current as the family adds rows. */
 function SentFormView ({ code }) {
  const [form, setForm] = _react.useState(null)
  const [error, setError] = _react.useState.call(void 0, '')
  const [tab, setTab] = _react.useState('page')
  const { showSuccessBar, showWarningBar } = _noticeBar.useNoticeBar.call(void 0, )

  const load = _react.useCallback.call(void 0, () => {
    _forms.getSentForm.call(void 0, { Code: code })
      .then(({ Form }) => {
        setForm(Form)
        setError('')
      })
      .catch(err => setError(_forms.formsErrorText.call(void 0, err, "Couldn't open this form. Try again.")))
  }, [code])

  _react.useEffect.call(void 0, () => {
    setForm(null)
    setError('')
    load()
  }, [load])
  _react.useEffect.call(void 0, () => _forms.onFormChanged.call(void 0, notice => {
    if (notice.Code === code) load()
  }), [code, load])

  const familyLink = _optionalChain([form, 'optionalAccess', _10 => _10.FamilyLink])
  const copyLink = _react.useCallback.call(void 0, () => {
    if (!familyLink) return
    _ui.copyToClipboard.call(void 0, familyLink)
      .then(() => showSuccessBar('Link copied'))
      .catch(() => showWarningBar("Couldn't copy the link"))
  }, [familyLink, showSuccessBar, showWarningBar])
  const chatKey = _optionalChain([form, 'optionalAccess', _11 => _11.ChatKey])
  const back = _react.useCallback.call(void 0, () => {
    if (chatKey) _openFormChat.openFormChat.call(void 0, chatKey).catch(() => _store.history.push('/inbox'))
    else _store.history.push('/inbox')
  }, [chatKey])
  const goToChats = _react.useCallback.call(void 0, () => _store.history.push('/inbox'), [])

  if (error && !form) {
    return (
      _react2.default.createElement('div', { className: "forms-status forms-status--refused" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 124}}
        , _react2.default.createElement('div', { className: "forms-blank", __self: this, __source: {fileName: _jsxFileName, lineNumber: 125}}
          , _react2.default.createElement('h3', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 126}}, "This form can't be shown"    )
          , _react2.default.createElement('p', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 127}}, error)
          , _react2.default.createElement('button', { type: "button", className: "forms-link", onClick: goToChats, __self: this, __source: {fileName: _jsxFileName, lineNumber: 128}}, "Back to Chats"  )
        )
      )
    )
  }
  if (!form) return _react2.default.createElement('div', { className: "forms-status", __self: this, __source: {fileName: _jsxFileName, lineNumber: 133}}, _react2.default.createElement('p', { className: "forms-muted forms-status--loading" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 133}}, "Loading the form…"  ))

  const log = _forms.isLogForm.call(void 0, form.Form.fields)
  const month = _forms.isSetTime.call(void 0, form.LogMonth) ? ` · ${_forms.logMonthName.call(void 0, form.LogMonth)}` : ''
  const updating = log && _forms.isOpenStatus.call(void 0, form.Status)
  const valueOf = valueFor(form)

  return (
    _react2.default.createElement('div', { className: "forms-status", __self: this, __source: {fileName: _jsxFileName, lineNumber: 141}}
      , _react2.default.createElement('header', { className: "forms-status--header", __self: this, __source: {fileName: _jsxFileName, lineNumber: 142}}
        , _react2.default.createElement('button', { type: "button", className: "forms-icon-button", 'aria-label': "Back to the chat"   , onClick: back, __self: this, __source: {fileName: _jsxFileName, lineNumber: 143}}
          , _react2.default.createElement('i', { className: "material-icons", 'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 144}}, "arrow_back")
        )
        , _react2.default.createElement('h1', { className: "forms-status--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 146}}, form.FormName, form.PatientName ? ` · ${form.PatientName}` : '', month)
        , _react2.default.createElement(_FormStatusChip2.default, { card: form, withRows: log, __self: this, __source: {fileName: _jsxFileName, lineNumber: 147}} )
        ,  updating && (
          _react2.default.createElement('span', { className: "forms-muted forms-status--live" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 149}}, "Updates as "
              , _forms.firstName.call(void 0, form.PatientName || 'the family'), " adds rows. Not signed yet."
          )
        )
        , _react2.default.createElement('span', { className: "forms-status--spacer", __self: this, __source: {fileName: _jsxFileName, lineNumber: 153}} )
        ,  log && (
          _react2.default.createElement('div', { className: "tdlg-seg", role: "group", 'aria-label': "Show", __self: this, __source: {fileName: _jsxFileName, lineNumber: 155}}
            ,  (['page', 'rows'] ).map(value => (
              _react2.default.createElement('button', {
                key: value,
                type: "button",
                'aria-pressed': tab === value,
                className: _classBuilder2.default.call(void 0, 'tdlg-seg--item', tab === value && 'tdlg-seg--on'),
                onClick: () => setTab(value), __self: this, __source: {fileName: _jsxFileName, lineNumber: 157}}

                , value === 'page' ? 'Page' : 'Rows'
              )
            ))
          )
        )
        ,  form.Status !== 'expired' && form.Status !== 'completed' && (
          _react2.default.createElement('button', { type: "button", className: "tdlg-btn tdlg-btn--out" , onClick: copyLink, __self: this, __source: {fileName: _jsxFileName, lineNumber: 170}}
            , _react2.default.createElement('i', { className: "material-icons", 'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 171}}, "content_copy"), " Copy link"
          )
        )
      )
      ,  error && _react2.default.createElement('p', { className: "forms-error", role: "alert", __self: this, __source: {fileName: _jsxFileName, lineNumber: 175}}, error) 
      , _react2.default.createElement('div', { className: "forms-status--body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 176}}
        ,  tab === 'rows' && log
          ? _react2.default.createElement(RowsList, { form: form, __self: this, __source: {fileName: _jsxFileName, lineNumber: 178}} )
          : (form.Pages || []).map((page, i) => (
            _react2.default.createElement(_FilledPage2.default, {
              key: page.FileKey,
              page: page,
              pageIndex: i,
              fields: form.Form.fields,
              valueOf: valueOf,
              rows: _optionalChain([form, 'access', _12 => _12.Answers, 'optionalAccess', _13 => _13.rows]) || [],
              label: `${form.FormName}, page ${i + 1}`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 180}}
            )
            ))
      )
    )
  )
} exports.default = SentFormView;
